import { Environment } from './environment.interface';
export { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: 'https://api.nominations.dev-apps.enelx.net/v1',
      globalNavUrl: 'https://nav.payments.dev-apps.enelx.net/v1/menu',
    },
  },
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
  },
};
